import PropTypes from "prop-types"
import React from "react"
import { useForm } from "react-hook-form"
import { useMutation } from "react-query"

import Button from "src/components/Button"
import Form from "src/components/Form"

import { createStripeAccount } from "src/api/Onboarding/Claim"

const StripeAccountCreation = ({ smaCountries, onAccountCreated }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm()
  const selectedCountry = watch("country")

  const createAccountMutation = useMutation(
    (data) => createStripeAccount({ data }),
    {
      onSuccess: (response) => {
        onAccountCreated(response.stripe_managed_account_id)
      },
    }
  )

  const onSubmit = (data) => {
    createAccountMutation.mutate(data)
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="mb-2 text-lg font-semibold">
          Select your bank location to get started
        </h3>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-start text-start">
          <Form.Label htmlFor="sma-country">Bank Location</Form.Label>
          <Form.Select
            id="sma-country"
            {...register("country", {
              required: "Please select a country",
            })}
          >
            <option value="">Select a country</option>
            {smaCountries.map((country) => (
              <option key={country.countryCode} value={country.countryCode}>
                {country.name}
              </option>
            ))}
          </Form.Select>
          <div className="my-2">
            <Button
              type="submit"
              variant="primary"
              disabled={!selectedCountry || createAccountMutation.isLoading}
            >
              {createAccountMutation.isLoading
                ? "Creating Stripe Account"
                : "Create Stripe Account"}
            </Button>
          </div>
          {errors.country && <Form.Error>{errors.country.message}</Form.Error>}
          {createAccountMutation.error && (
            <Form.Error>{createAccountMutation.error.message}</Form.Error>
          )}
        </div>
      </Form>
    </div>
  )
}

StripeAccountCreation.propTypes = {
  smaCountries: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onAccountCreated: PropTypes.func.isRequired,
}

export default StripeAccountCreation
